export const IconSearchNF = () => {
  return (
    <svg
      width="101"
      height="111"
      viewBox="0 0 101 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M87 55.5V22.6798C87 21.8443 86.6682 21.0431 86.0776 20.4524L69.5474 3.92264C68.9568 3.33185 68.1556 3 67.3204 3H6.15C4.41031 3 3 4.41031 3 6.15V104.85C3 106.59 4.41031 108 6.15 108H39.75"
        stroke="#053462"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 45H66M24 24H45M24 66H39.75"
        stroke="#053462"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.625 100.125L97.5 108"
        stroke="#053462"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.75 87C60.75 95.6987 67.8013 102.75 76.5 102.75C80.857 102.75 84.8002 100.981 87.6515 98.1221C90.4933 95.2729 92.25 91.3418 92.25 87C92.25 78.3013 85.1987 71.25 76.5 71.25C67.8013 71.25 60.75 78.3013 60.75 87Z"
        stroke="#053462"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66 3V20.85C66 22.5897 67.4102 24 69.15 24H87"
        stroke="#053462"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
